import { SubAPI } from "./SubAPI";
import {DateString} from "./Projects";

export class UserNotifications extends SubAPI {

    list(input: {}) {
        return this.fetcher.get<UserNotif[]>("/api/user-notifications", input)
    }

    upsert(input: UserNotif) {
        return this.fetcher.post("/api/user-notification", input);
    }

    upsertBulk(input: {
        list: UserNotif[]
    }) {
        return this.fetcher.post("/api/user-notification/bulk", input);
    }
}

export type UserNotif = {
    id: number;
    usr: number;
    task2: number | null;
    task2Comment: number | null;
    board: number | null;

    kind: ""
    overline: string;
    content: string;
    read: boolean;
    archived: boolean;
    createdAt: DateString;
}